module.exports = __webpack_public_path__ + "img/12.17997b78.jpg";